import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const trackerInstanceSectionDetail = async (identifier) => {
  const url = `${BASE_URL}/v1/trackers/instances/sections/${identifier}/detail/`;
  return await requestSdk(() => get(url));
};
